import type { UserInfo } from '../../shared/types';
import { PASSWORD_RULES_TEXT, validatePassword } from '../../shared/password';
import { api, errorMessage } from '../api';
import { field, h } from '../ui';

const LAST_USER_KEY = 'fk-last-user';

export function renderLogin(root: HTMLElement, onLoggedIn: (name: string) => Promise<void>): void {
  const card = h('div', { class: 'login-card' }, h('h2', {}, 'Anmelden'), h('p', { class: 'muted' }, 'Benutzer werden geladen …'));
  root.append(h('div', { class: 'login-wrap' }, card));

  const build = (users: UserInfo[]): void => {
    const userSel = h('select');
    for (const u of users) userSel.append(h('option', { value: u.name }, u.name));
    try {
      const last = localStorage.getItem(LAST_USER_KEY);
      if (last && users.some((u) => u.name === last)) userSel.value = last;
    } catch {
      /* ignorieren */
    }

    const fields = h('div');
    const msg = h('div', { class: 'error', role: 'alert' });
    const submit = h('button', { type: 'submit', class: 'btn btn-primary wide' });
    let isNew = false;
    let pw: HTMLInputElement = h('input', { type: 'password' });
    let pw2: HTMLInputElement | null = null;

    const drawFields = (): void => {
      const u = users.find((x) => x.name === userSel.value);
      isNew = !!u && !u.hasPassword;
      pw = h('input', { type: 'password', autocomplete: isNew ? 'new-password' : 'current-password' });
      pw2 = null;
      fields.replaceChildren(field('Passwort', pw));
      if (isNew) {
        const second = h('input', { type: 'password', autocomplete: 'new-password' });
        pw2 = second;
        fields.append(field('Wiederholen', second), h('p', { class: 'hint' }, `Für diesen Benutzer ist noch kein Passwort festgelegt. ${PASSWORD_RULES_TEXT}`));
      }
      submit.textContent = isNew ? 'Passwort festlegen und anmelden' : 'Anmelden';
      msg.textContent = '';
      pw.focus();
    };

    const form = h('form', { novalidate: true }, field('Benutzer', userSel), fields, msg, submit);
    form.addEventListener('submit', async (ev) => {
      ev.preventDefault();
      msg.textContent = '';
      const name = userSel.value;
      try {
        if (isNew) {
          const err = validatePassword(pw.value);
          if (err) {
            msg.textContent = err;
            return;
          }
          if (pw.value !== pw2?.value) {
            msg.textContent = 'Die Passwörter stimmen nicht überein.';
            return;
          }
          await api.setupPassword(name, pw.value);
        } else {
          await api.login(name, pw.value);
        }
        try {
          localStorage.setItem(LAST_USER_KEY, name);
        } catch {
          /* ignorieren */
        }
        await onLoggedIn(name);
      } catch (e) {
        msg.textContent = errorMessage(e);
      }
    });
    userSel.addEventListener('change', drawFields);

    card.replaceChildren(h('h2', {}, 'Anmelden'), form);
    drawFields();
  };

  api
    .users()
    .then(build)
    .catch((e: unknown) => card.replaceChildren(h('h2', {}, 'Anmelden'), h('p', { class: 'error' }, errorMessage(e))));
}
